import { render, staticRenderFns } from "./PopularScienceDemo.vue?vue&type=template&id=32b26f56&scoped=true&"
import script from "./PopularScienceDemo.vue?vue&type=script&lang=js&"
export * from "./PopularScienceDemo.vue?vue&type=script&lang=js&"
import style0 from "./PopularScienceDemo.vue?vue&type=style&index=0&id=32b26f56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b26f56",
  null
  
)

export default component.exports